module.exports = __webpack_public_path__ + "media/application/images/svgs/more-horizontal-f2e2be982690eee81132f939d068147f.svg";